$(document).ready(function() {
    $("img.attachment-thumbnail").parent("a").addClass("thickbox");
});

// Slick
    $(document).ready(function(){
      $('.slideshow').slick({
	 		 prevArrow: "<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
	 		 nextArrow: "<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></button>",
  		});
    });
    
// WOW Initialize
	new WOW().init();


// Parallax Scroll
var parallax = document.querySelectorAll(".parallax");
var	speed = -0.25;
var ww = document.body.clientWidth;

	window.onscroll = function() {
		[].slice.call(parallax).forEach(function(el, i) {
	
			var windowYOffset = window.pageYOffset,
				elBackgrounPos = "50% " + (windowYOffset * speed + i * 200) + "px";
	
			el.style.backgroundPosition = elBackgrounPos;
	
		});
	};

function isIE () {
    var myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
}

window.isIEOld = isIE() && isIE() < 9;
window.isiPad = navigator.userAgent.match(/iPad/i);

var img = $('.video').data('placeholder'),
    video = $('.video').data('video'),
    noVideo = $('.video').data('src'),
    el = '';

if($(window).width() > 599 && !isIEOld && !isiPad) {
    el +=   '<video autoplay loop poster="' + img + '">';
    el +=       '<source src="' + video + '" type="video/mp4">';
    el +=   '</video>';
} else {
    el = '<div class="video-element" style="background-image: url(' + noVideo + ')"></div>';
}

$('.video').prepend(el);